/**
 * Bestseller-Tabs — schaltet zwischen den Tab-Panels um.
 *
 * Alle Panels liegen bereits im DOM; hier wird nur sichtbar/unsichtbar
 * geschaltet. Kein Nachladen, kein Netzwerk-Roundtrip beim Tab-Wechsel.
 *
 * Tastaturbedienung nach dem ARIA-Muster für Tabs:
 * Pfeil links/rechts wechselt, Pos1/Ende springt an den Rand.
 */
class BestsellerTabsComponent extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    if (this.tabs.length === 0) return;

    this.addEventListener('click', this.#onClick);
    this.addEventListener('keydown', this.#onKeydown);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
    this.removeEventListener('keydown', this.#onKeydown);
  }

  #onClick = (event) => {
    const tab = event.target.closest('[role="tab"]');
    if (!tab || !this.contains(tab)) return;
    this.#select(tab);
  };

  #onKeydown = (event) => {
    const tab = event.target.closest('[role="tab"]');
    if (!tab || !this.contains(tab)) return;

    const index = this.tabs.indexOf(tab);
    let next = null;

    switch (event.key) {
      case 'ArrowRight':
        next = this.tabs[(index + 1) % this.tabs.length];
        break;
      case 'ArrowLeft':
        next = this.tabs[(index - 1 + this.tabs.length) % this.tabs.length];
        break;
      case 'Home':
        next = this.tabs[0];
        break;
      case 'End':
        next = this.tabs[this.tabs.length - 1];
        break;
      default:
        return;
    }

    event.preventDefault();
    this.#select(next);
    next.focus();
  };

  #select(tab) {
    if (tab.getAttribute('aria-selected') === 'true') return;

    for (const item of this.tabs) {
      const selected = item === tab;
      const panel = this.querySelector(`#${CSS.escape(item.getAttribute('aria-controls'))}`);

      item.setAttribute('aria-selected', String(selected));
      item.setAttribute('tabindex', selected ? '0' : '-1');
      if (panel) panel.toggleAttribute('hidden', !selected);
    }

    // Aktiven Tab in den sichtbaren Bereich holen, wenn die Leiste scrollt
    tab.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
  }
}

if (!customElements.get('bestseller-tabs-component')) {
  customElements.define('bestseller-tabs-component', BestsellerTabsComponent);
}
